<svg width="23" height="10" viewBox="0 0 23 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.5 9H21.5C22.0523 9 22.5 8.55228 22.5 8V1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
